<div class="modal-body">
    <table class="table table-striped">
        <tr ng-repeat="form in modal.forms">
            <td>{{ form.name}}</td>
            <td>
                <button class="btn btn-success btn-sm pull-right" ng-click="modal.open(form)">Open</button>
                <button class="btn btn-danger margin-right-20 btn-sm pull-right" ng-click="modal.delete($index, form)">Delete</button>
            </td>
        </tr>
    </table>
</div>
<div class="modal-footer">
    <button class="btn btn-success btn-sm" type="button" ng-click="modal.open({fields: []})">New Form</button>
    <button class="btn btn-warning btn-sm" type="button" ng-click="modal.cancel()">Cancel</button>
</div>